import React from 'react';
import '../template-file-css/document-file-template.css';


export const RRTS_HealthWellnessQuestionnaire = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RRTS_HealthWellnessQuestionnaire' className='file-pdf-document'>
            <div className='file-template'>
                <p>
                    People who are prescribed atypical antipsychotics are at increased risk of developing metabolic syndrome. Many individuals with schizophrenia, bipolar disorder, and psychotic disorder are prescribed atypical antipsychotics to treat the serious symptoms of these disorders. Depression is also linked to higher risk of diabetes and cardiovascular disease. It's critical that these individuals have their weight, blood sugar, blood pressure, and cholesterol routinely monitored by their doctor along with education on healthy lifestyle choices.
                </p>
                <p>
                    <strong>Integrated Health Care Management Services are available with AmeriHealth Caritas Louisiana. You may contact a care manager at 1-888-643-0005.</strong>
                </p>
                <p>
                    <strong>Provider Instructions:</strong>
                </p>
                <p>
                    <strong>Fax the completed form to Rapid Response at 1-855-345-2048 to follow up on any services and/or appointments to assist the member.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Behavioral Health Provider Name:</span>
                            <input type="text" name="txtBehavioralHealth" id="txtBehavioralHealth" className='add-only'  />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Completing Staff Member Name:</span>
                            <input type="text" name="txtCompletingStaff" id="txtCompletingStaff" className='add-only'  />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Completed:</span>
                            <input type="date" name="txtDateCompleted" id="txtDateCompleted" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Name:</span>
                            <input type="text" name="txtBehavioralHealth1" id="txtBehavioralHealth1" className='add-only'  />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid ID:</span>
                            <input type="text" name="txtCompletingStaff1" id="txtCompletingStaff1" className='add-only'  />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Birth:</span>
                            <input type="date" name="txtDateCompleted1" id="txtDateCompleted1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary Care Provider Name:</span>
                            <input type="text" name="txtBehavioralHealth3" id="txtBehavioralHealth3" className='add-only'  />
                        </td>
                        <td className='w-250'>&nbsp; </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                </table>
                <p>
                    <strong>1. Living Situation</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Where do you currently live?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="checkbox" name="chkSibHow" id="chkSibHow" className='add-only' value="1" /> House/Apartment
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="chkSibHow1" id="chkSibHow1" className='add-only' value="2" /> Assisted Living
                        </td>
                        <td className='w-175'>
                            <input type="checkbox" name="chkSibHow2" id="chkSibHow2" className='add-only' value="3" />  Shelter
                        </td>
                        <td className='w-175'>
                            <input type="checkbox" name="chkSibHow3" id="chkSibHow3" className='add-only' value="4" /> Homeless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Who do you live with?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="checkbox" name="chkSibHow4" id="chkSibHow4" className='add-only' value="1" /> Alone
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="chkSibHow11" id="chkSibHow11" className='add-only' value="2" /> Roommate
                        </td>
                        <td className='w-175'>
                            <input type="checkbox" name="chkSibHow21" id="chkSibHow21" className='add-only' value="3" />  Partner/Spouse
                        </td>
                        <td className='w-175'>
                            <input type="checkbox" name="chkSibHow31" id="chkSibHow31" className='add-only' value="4" />  Adult Family
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="checkbox" name="chkSibHow41" id="chkSibHow41" className='add-only' value="1" /> Minor Children
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="chkSibHow51" id="chkSibHow51" className='add-only' value="2" /> Supervised
                        </td>
                        <td className='w-175'>&nbsp;
                        </td>
                        <td className='w-175'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>2. Hospital/Office Visit History</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>In the past 12 months how many times have you:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-125'>
                            <strong>Never</strong>
                        </td>
                        <td className='w-125'>
                            <strong>1 - 2</strong>
                        </td>
                        <td className='w-125'>
                            <strong>3 - 5</strong>
                        </td>
                        <td className='w-125'>
                            <strong>6 or More</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Visited a doctor's office
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite_Yes" name="rbSite" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite_Y" name="rbSite" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite_Ye" name="rbSite" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite_Ys" name="rbSite" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Gone to the emergency room
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite1_Yes" name="rbSite1" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite1_Y" name="rbSite1" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite1_Ye" name="rbSite1" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite1_Ys" name="rbSite" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Stayed overnight in a hospital
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite2_Yes" name="rbSite2" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite2_Y" name="rbSite2" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite2_Ye" name="rbSite2" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSite2_Ys" name="rbSite2" className='add-only' value="4" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>3. Cholesterol checked</strong>
                </p>
                <p>
                    Date of last test:<input type="date" name="txtCholesterol" id="txtCholesterol" className='add-only' />
                </p>
                <p>
                    If unknown: recommendation is to follow up with PCP
                    <textarea id="txtCholesterol2" name="txtCholesterol2" className='add-only'></textarea>
                </p>
                <p>
                    <strong>4. Glucose Levels checked</strong>
                </p>
                <p>
                    Date of last test:<input type="date" name="txtGlucose" id="txtGlucose" className='add-only' />
                </p>
                <p>
                    If unknown: recommendation is to follow up with PCP
                    <textarea id="txtCholesterol21" name="txtCholesterol21" className='add-only'></textarea>
                </p>
                <p>
                    <strong>5. Vitals</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date taken:</span>
                            <input type="date" name="txtDateTaken" id="txtDateTaken" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Temp:</span>
                            <input type="text" name="txtTemp" id="txtTemp" className='add-only'  />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Pulse:</span>
                            <input type="text" name="txtPulse" id="txtPulse" className='add-only'  />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Height:</span>
                            <input type="text" name="txtHeight" id="txtHeight" className='add-only'  />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Weight:</span>
                            <input type="text" name="txtWeight" id="txtWeight" className='add-only'  />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>BMI:</span>
                            <input type="text" name="txtBmi" id="txtBmi" className='add-only'  />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Waist:</span>
                            <input type="text" name="txtWaist" id="txtWaist" className='add-only'  />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>6. Social Activity</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>How often do you do the following:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-125'>
                            <strong>Never</strong>
                        </td>
                        <td className='w-125'>
                            <strong>Rarely</strong>
                        </td>
                        <td className='w-125'>
                            <strong>Sometimes</strong>
                        </td>
                        <td className='w-125'>
                            <strong>Frequently</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Receive invitations to go out and do things
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive_Yes" name="rbReceive" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive_Y" name="rbReceive" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive_Ye" name="rbReceive" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive_Ys" name="rbReceive" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Talk to someone about personal/family problems
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive1_Yes" name="rbReceive1" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive1_Y" name="rbReceive11" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive1_Ye" name="rbReceive1" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbReceive1_Ys" name="rbReceive1" className='add-only' value="4" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>7. Physical Activity</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>How often do you do the following:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-125'>
                            <strong>Never</strong>
                        </td>
                        <td className='w-125'>
                            <strong>Rarely</strong>
                        </td>
                        <td className='w-125'>
                            <strong>Sometimes</strong>
                        </td>
                        <td className='w-125'>
                            <strong>Frequently</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Go to the gym
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym_Yes" name="rbGym" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym_Y" name="rbGym" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym_Ye" name="rbGym" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym_Ys" name="rbGym" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Walk or run
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym1_Yes" name="rbGym1" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym1_Y" name="rbGym1" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym1_Ye" name="rbGym1" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym1_Ys" name="rbGym1" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Other<input type="text" name="txtOther" id="txtOther" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym2_Yes" name="rbGym2" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym2_Y" name="rbGym2" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym2_Ye" name="rbGym2" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbGym2_Ys" name="rbGym2" className='add-only' value="4" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>8. Preventative Test History</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>When was the last time you've had:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>&nbsp;
                        </td>
                        <td className='w-100'>
                            <strong>Never</strong>
                        </td>
                        <td className='w-100'>
                            <strong>Less Than 1 Year</strong>
                        </td>
                        <td className='w-100'>
                            <strong>1 - 2 Year</strong>
                        </td>
                        <td className='w-100'>
                            <strong>3 - 4 Year</strong>
                        </td>
                        <td className='w-100'>
                            <strong>5 + Year</strong>
                        </td>
                        <td className='w-100'>
                            <strong>Don't Know</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Colon cancer screen
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon_Yes" name="rbColon" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon_Y" name="rbColon" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon_Ye" name="rbColon" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon_Ys" name="rbColon" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon_Yer" name="rbColon" className='add-only' value="5" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon_Yst" name="rbColon" className='add-only' value="6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Flu vaccine
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon1_Yes" name="rbColon1" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon1_Y" name="rbColon1" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon1_Ye" name="rbColon1" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon1_Ys" name="rbColon1" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon1_Yer" name="rbColon1" className='add-only' value="5" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon1_Yst" name="rbColon1" className='add-only' value="6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Pneumonia vaccine
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon2_Yes" name="rbColon2" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon2_Y" name="rbColon2" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon2_Ye" name="rbColon2" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon2_Ys" name="rbColon2" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon2_Yer" name="rbColon2" className='add-only' value="5" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon2_Yst" name="rbColon2" className='add-only' value="6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Tetanus vaccine
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon3_Yes" name="rbColon3" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon3_Y" name="rbColon3" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon3_Ye" name="rbColon3" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon3_Ys" name="rbColon3" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon3_Yer" name="rbColon3" className='add-only' value="5" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon3_Yst" name="rbColon3" className='add-only' value="6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Dental exam
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon4_Yes" name="rbColon4" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon4_Y" name="rbColon4" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon4_Ye" name="rbColon4" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon4_Ys" name="rbColon4" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon4_Yer" name="rbColon4" className='add-only' value="5" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon4_Yst" name="rbColon4" className='add-only' value="6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Pap test
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon5_Yes" name="rbColon5" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon5_Y" name="rbColon5" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon5_Ye" name="rbColon5" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon5_Ys" name="rbColon5" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon5_Yer" name="rbColon5" className='add-only' value="5" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon5_Yst" name="rbColon5" className='add-only' value="6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Mammogram
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon6_Yes" name="rbColon6" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon6_Y" name="rbColon6" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon6_Ye" name="rbColon6" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon6_Ys" name="rbColon6" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon6_Yer" name="rbColon6" className='add-only' value="5" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbColon6_Yst" name="rbColon6" className='add-only' value="6" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>9. Chronic Condition History</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you have any of the following conditions:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-100'>
                            <strong>Never</strong>
                        </td>
                        <td className='w-100'>
                            <strong>In the Past</strong>
                        </td>
                        <td className='w-100'>
                            <strong>Currently Diagnosed</strong>
                        </td>
                        <td className='w-100'>
                            <strong>Currently Taking Medication</strong>
                        </td>
                        <td className='w-100'>
                            <strong>Under Medical Care</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Allergies
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical_Yes" name="rbMedical" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical_Y" name="rbMedical" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical_Ye" name="rbMedical" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical_Ys" name="rbMedical" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical_Yer" name="rbMedical" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Asthma
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical1_Yes" name="rbMedical1" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical1_Y" name="rbMedical1" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical1_Ye" name="rbMedical1" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical1_Ys" name="rbMedical1" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical1_Yer" name="rbMedical1" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Bronchitis/COPD
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical2_Yes" name="rbMedical2" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical2_Y" name="rbMedical2" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical2_Ye" name="rbMedical2" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical2_Ys" name="rbMedical2" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical2_Yer" name="rbMedical2" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Chronic pain
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical3_Yes" name="rbMedical3" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical3_Y" name="rbMedical3" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical3_Ye" name="rbMedical3" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical3_Ys" name="rbMedical3" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical3_Yer" name="rbMedical3" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Diabetes
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical4_Yes" name="rbMedical4" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical4_Y" name="rbMedical4" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical4_Ye" name="rbMedical4" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical4_Ys" name="rbMedical4" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical4_Yer" name="rbMedical4" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Heart problems
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical5_Yes" name="rbMedical5" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical5_Y" name="rbMedical5" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical5_Ye" name="rbMedical5" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical5_Ys" name="rbMedical5" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical5_Yer" name="rbMedical5" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>High blood pressure
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical6_Yes" name="rbMedical6" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical6_Y" name="rbMedical6" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical6_Ye" name="rbMedical6" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical6_Ys" name="rbMedical6" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical6_Yer" name="rbMedical6" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Stroke
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical7_Yes" name="rbMedical7" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical7_Y" name="rbMedical7" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical7_Ye" name="rbMedical7" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical7_Ys" name="rbMedical7" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical7_Yer" name="rbMedical7" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>HIV
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical8_Yes" name="rbMedical8" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical8_Y" name="rbMedical8" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical8_Ye" name="rbMedical8" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical8_Ys" name="rbMedical8" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical8_Yer" name="rbMedical8" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Hepatitis
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical9_Yes" name="rbMedical9" className='add-only' value="1" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical9_Y" name="rbMedical9" className='add-only' value="2" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical9_Ye" name="rbMedical9" className='add-only' value="3" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical9_Ys" name="rbMedical9" className='add-only' value="4" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbMedical9_Yer" name="rbMedical9" className='add-only' value="5" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Considering your age, how would you rate your overall health:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <strong>Poor</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Not Good</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Average</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Good</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Excellent</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="radio" id="rbAverage_Yes" name="rbAverage" className='add-only' value="1" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbAverage_Y" name="rbAverage" className='add-only' value="2" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbAverage_Ye" name="rbAverage" className='add-only' value="3" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbAverage_Ys" name="rbAverage" className='add-only' value="4" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbAverage_Yer" name="rbAverage" className='add-only' value="5" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>10. Wellness Education: Please check the topics you would like additional information on:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <strong>Topics</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Yes</strong>
                        </td>
                        <td className='w-150'>
                            <strong>No</strong>
                        </td>
                        <td className='w-150'>
                            <strong>Uncertain</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Nutrition
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition1_Ys" name="rbNutrition1" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition1_Nol" name="rbNutrition1" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition1_Yse" name="rbNutrition1" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Healthy Cooking
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition2_Ys" name="rbNutrition2" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition2_Nol" name="rbNutrition2" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition2_Yse" name="rbNutrition2" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Physical Activity/Exercise
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition3_Ys" name="rbNutrition3" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition3_Nol" name="rbNutrition3" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition3_Yse" name="rbNutrition3" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Smoking Cessation
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition4_Ys" name="rbNutrition4" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition4_Nol" name="rbNutrition4" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition4_Yse" name="rbNutrition4" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Stress Management
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition5_Ys" name="rbNutrition5" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition5_Nol" name="rbNutrition5" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition5_Yse" name="rbNutrition5" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Recovery Activities
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition6_Ys" name="rbNutrition6" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition6_Nol" name="rbNutrition6" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition6_Yse" name="rbNutrition6" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Peer Support
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition7_Ys" name="rbNutrition7" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition7_Nol" name="rbNutrition7" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition7_Yse" name="rbNutrition7" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Medical Management
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition8_Ys" name="rbNutrition8" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition8_Nol" name="rbNutrition8" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition8_Yse" name="rbNutrition8" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>GED
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition9_Ys" name="rbNutrition9" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition9_Nol" name="rbNutrition9" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition9_Yse" name="rbNutrition9" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Vocation/PreVocation
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition10_Ys" name="rbNutrition10" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition10_Nol" name="rbNutrition10" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition10_Yse" name="rbNutrition10" className='add-only' value="Yse" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Other, specify:
                            <input type='text' id="txtExerciseOther1" name="txtExerciseOther11" className='add-only'  />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition11_Ys" name="rbNutrition11" className='add-only' value="Ys" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition11_Nol" name="rbNutrition11" className='add-only' value="Nol" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbNutrition11_Yse" name="rbNutrition11" className='add-only' value="Yse" />
                        </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}   